<template>
    <v-data-table
        :headers="headers"
        :items="files"
        :items-per-page="5"
        :items-per-page-options="[5, 10, 20, 100]"
        height="400"
        item-value="name"
    >
        <template v-slot:[`item.tipoDocumentacion`]="{ item }">
            <v-chip
                color="primary"
                class="white--text"
            >
                {{ tipoDocumentacion(item.tipoDocumentacion) }}
            </v-chip>
        </template>
        <template v-slot:[`item.contenidoBase64`]="{ item }">
            <v-row class="align-center justify-start" dense>
                <v-col cols="12" :md="mostrarEliminar ? 4 : 5" v-if="mostrarEnviar">
                    <v-tooltip text="Enviar documento a IOMA" location="top">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                color="red"
                                v-bind="props"
                                @click="enviarDocuIOMA(item.guid)"
                                icon="mdi mdi-upload"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" :md="mostrarEliminar ? 4 : 5" v-if="mostrarNewTab">
                    <v-tooltip text="Ver documento" location="top">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                @click="openFileInNewTab(item.tipoMime, item.nombre, item.guid ? item.guid : item.id)"
                                icon="mdi mdi-eye"
                            >
                            </v-btn>
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col  cols="12" :md="mostrarEliminar ? 4: 5" v-if="mostrarDownload">
                    <v-tooltip text="Descargar documento" location="top">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                @click="downloadFile(item.tipoMime, item.nombre, item.guid ? item.guid : item.id)"
                                icon="mdi mdi-download"
                            >
                            </v-btn>
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col  cols="12" md="4" v-if="mostrarEliminar">
                    <v-tooltip text="Eliminar documento" location="top">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-if="!esDeReintegros && !esAuditor"
                                v-bind="props"
                                @click="elimimarArchivo(item.dominio, item.guid ? item.guid : item.id, item.idSolicitudPractica,item.tipoDocumentacion)"
                                icon="mdi mdi-trash-can"
                            >
                            </v-btn>
                        </template>
                    </v-tooltip>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<style src="../assets/general.css"></style>

<script>

    export default {
        name: 'ImageTable',
        props: {
            files: {
                type: Array,
                required: true
            },
            mostrarEnviar:{
                type: Boolean,
                default: false
            },
            mostrarEliminar: {
                type: Boolean,
                default: false
            },
            mostrarNewTab: {
                type: Boolean,
                default: true
            },
            mostrarDownload: {
                type: Boolean,
                default: true
            },
            headers: {
                type: Array,
                required: true
            },
            esDeReintegros: {
                type: Boolean,
                default: false
            },
            esAuditor: {
                type: Boolean,
                default: false
            },
            tiposDocumentacion: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                tiposDocumentacionLocal: []
            };
        },
        mounted() {
            this.tiposDocumentacionLocal = this.tiposDocumentacion;
            this.tiposDocumentacionLocal.push({valor:3, nombre:'Carnet afiliado'});
        },
        computed: {
            tipoDocumentacion() {
                return (valor) => {
                    const tipo = this.tiposDocumentacionLocal.find(tipo => tipo.valor === valor);
                    return tipo ? tipo.nombre : null;
                };
            }
        },
        methods: {
            openFileInNewTab(tipoMime, nombre, guid) {
                console.log('Opening file in new tab: ', { tipoMime, nombre, guid });
                this.$emit('open-file-in-new-tab', { tipoMime, nombre, guid });
            },
            downloadFile(tipoMime, nombre, guid) {
                this.$emit('download-file', { tipoMime, nombre, guid });
            },
            elimimarArchivo(dominio, idArchivo, idSolicitudPractica,tipoDocumentacion) {
                this.$emit('eliminar-archivo', { dominio, idArchivo, idSolicitudPractica,tipoDocumentacion });
            },
            enviarDocuIOMA(guid){
                this.$emit('enviar-docu-IOMA',{guid})
            }
        },
    }
</script>